__turbopack_context__.v({
  "content": "UV7Oza_content",
  "form": "UV7Oza_form",
  "logo": "UV7Oza_logo",
  "shimmer": "UV7Oza_shimmer",
  "text-bar-sweep": "UV7Oza_text-bar-sweep",
});
